import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-44bc808e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "add-grounp-root-page main-scroll-topbar-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/add_grounp_top.png"
}, null, -1));

const _hoisted_3 = {
  class: "content-box"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/add-grounp-content-2.png"
}, null, -1));

const _hoisted_5 = ["src"];
import TopNavigator from "../components/TopNavigator.vue";
import { ref, onBeforeMount } from "vue";
import AV from "../assets/utils/av";
export default {
  __name: 'AddGrounp',
  props: {},

  setup(__props) {
    const props = __props;
    const addGrounpQrcode = ref("");
    onBeforeMount(() => {
      const qrcode = new AV.Query("ActiveQrCode");
      qrcode.equalTo("codeType", 0);
      qrcode.first().then(res => {
        const {
          src
        } = res && res.toJSON();
        addGrounpQrcode.value = src;
      }).catch(console.error);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "加入社群"
      }), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, addGrounpQrcode.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: addGrounpQrcode.value,
        class: "qrcode"
      }, null, 8, _hoisted_5)) : _createCommentVNode("", true)])])], 64);
    };
  }

};